<template>
  <section class="w-screen h-screen absolute flex justify-center z-50">
    <div id="modal modal-customer" class="modal absolute block w-5/12 bg-white shadow-md rounded-lg"
        :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
        }">
        <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
          <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Metode Pembayaran' : 'Tambah Metode Pembayaran' }}</h5>
        </div>
        <div id="modal-body" class="p-5">
          <InputText id="payment-method" v-model="description" label="Nama Metode Pembayaran" input_class="w-full"/>
        </div>
        <div class="modal-footer p-5">
          <div class="flex justify-center">
            <SubmitButton id="close" button_name="Close" button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal"/>
            <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4" @click="submitPaymentMethod"/>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import InputText from '../form/InputText.vue';
import SubmitButton from '../form/SubmitButton.vue';
import { mapActions } from 'vuex';

export default {
  name: "ModalPaymentMethod",
  props:{
    paymentMethod: {
      type: Object,
      default: null
    }
  },
  components: {
    InputText, SubmitButton
  },
  data() {
    return {
      showModal: true,
      description: this.paymentMethod ? this.paymentMethod.description : '',
      isEdit: !!this.paymentMethod
    };
  },
  methods: {
    ...mapActions('payment_methods', ['createPaymentMethod', 'updatePaymentMethod']),
    closeModal() {
      this.showModal = false;
      this.$emit('closeModal');
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200); 
    },
    async submitPaymentMethod() {
      try {
        const newPaymentMethod = {
          description: this.description
        };

        if(this.isEdit && this.paymentMethod) {
          newPaymentMethod.id = this.paymentMethod.id;
          await this.updatePaymentMethod(newPaymentMethod);
        }
        else {
          await this.createPaymentMethod(newPaymentMethod);
        }

        this.closeModal();
      }
      catch (error) {
        console.error('Failed to create payment method: ', error);
      }
    }
  }
}
</script>